import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {

  protected apiUrl = environment.apiUrl;
  protected usuarioUrl = `${this.apiUrl}/cloud-function-usuario`;
  constructor(protected http: HttpClient) { }

  getUsuarios(): Observable<any> {
    const headers = new HttpHeaders().set('accept', 'application/json');
    return this.http.get<any>(`${this.usuarioUrl}/usuario/`, { headers });
  }

  getCurrentUsuario(): Observable<any> {
    const headers = new HttpHeaders().set('accept', 'application/json');
    return this.http.get<any>(`${this.usuarioUrl}/usuario/whoami`, { headers }).pipe(
      tap(usuario => {
        sessionStorage.setItem('currentUser', JSON.stringify(usuario));
      })
    );
  }

  getUsuarioById(id: number): Observable<any> {
    const headers = new HttpHeaders().set('accept', 'application/json');
    return this.http.get<any>(`${this.usuarioUrl}/usuario/${id}`, { headers });
  }

  getUsuarioTipo(): Observable<any> {
    const headers = new HttpHeaders().set('accept', 'application/json');
    return this.http.get<any>(`${this.usuarioUrl}/tipo_usuario/lista`, { headers });
  }

  getPescadorTipo(): Observable<any> {
    const headers = new HttpHeaders().set('accept', 'application/json');
    return this.http.get<any>(`${this.usuarioUrl}/tipo_pescador/`, { headers });
  }

  addUsuario(usuario: any): Observable<any> {
    const headers = new HttpHeaders().set('accept', 'application/json');
    return this.http.post<any>(`${this.usuarioUrl}/usuario/`, usuario, { headers });
  }

  editUsuario(usuario: any, id: number): Observable<any> {
    const headers = new HttpHeaders().set('accept', 'application/json');
    return this.http.put<any>(`${this.usuarioUrl}/usuario/${id}`, usuario, { headers });
  }

  deleteUsuario(id: number): Observable<any> {
    const headers = new HttpHeaders().set('accept', 'application/json');
    return this.http.delete<any>(`${this.usuarioUrl}/usuario/${id}`, { headers });
  }
}
